import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DatosEmpresa } from '../../models/DatosEmpresa';

@Component({
  selector: 'app-snippet-empresa',
  templateUrl: './snippet-empresa.component.html',
  styleUrls: ['./snippet-empresa.component.scss']
})
export class SnippetEmpresaComponent {
  @Input() permiteSeleccionar: boolean = true;
  @Input() idEmpresa: string;
  @Input() empresaItem: DatosEmpresa;

  @Output() empresaSeleccionada = new EventEmitter<DatosEmpresa>();

  onSeleccionar() {
    this.empresaSeleccionada.emit(this.empresaItem);
  }
}
